import React from 'react';
import AccountSecurityScreenWeb from '@/modules/profile/components/AccountSecurityScreenWeb';

// Web-only Account & Security route
export default function AccountSecurityRoute() {
    return <AccountSecurityScreenWeb />;
}


